(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-announcement-section]';

    function parseLocalDate(value) {
      if (!value) return NaN;
      const match = value.trim().match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (match) {
        return new Date(
          Number(match[1]), Number(match[2]) - 1, Number(match[3]),
          Number(match[4]), Number(match[5]), Number(match[6] || 0)
        ).getTime();
      }
      return new Date(value).getTime();
    }

    function initTimer(section) {
      const wrap = section.querySelector('[data-countdown-wrap]');
      if (!wrap || wrap.dataset.initialized === 'true') return;
      wrap.dataset.initialized = 'true';

      const daysEl = wrap.querySelector('[data-time-days]');
      const hoursEl = wrap.querySelector('[data-time-hours]');
      const minutesEl = wrap.querySelector('[data-time-minutes]');
      const secondsEl = wrap.querySelector('[data-time-seconds]');
      const expiredEl = wrap.querySelector('[data-expired-message]');
      const endTime = parseLocalDate(section.dataset.endDate);

      if (![daysEl, hoursEl, minutesEl, secondsEl].every(Boolean) || !Number.isFinite(endTime)) {
        if (expiredEl) expiredEl.hidden = false;
        return;
      }

      let intervalId;
      const update = () => {
        const remaining = endTime - Date.now();
        if (remaining <= 0) {
          daysEl.textContent = hoursEl.textContent = minutesEl.textContent = secondsEl.textContent = '00';
          if (expiredEl) expiredEl.hidden = false;
          if (intervalId) window.clearInterval(intervalId);
          return;
        }
        const total = Math.floor(remaining / 1000);
        daysEl.textContent = String(Math.floor(total / 86400)).padStart(2, '0');
        hoursEl.textContent = String(Math.floor((total % 86400) / 3600)).padStart(2, '0');
        minutesEl.textContent = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
        secondsEl.textContent = String(total % 60).padStart(2, '0');
      };

      update();
      if (endTime > Date.now()) intervalId = window.setInterval(update, 1000);
    }

    function initRotator(section) {
      const rotator = section.querySelector('[data-ann-rotator]');
      if (!rotator || rotator.dataset.initialized === 'true') return;
      rotator.dataset.initialized = 'true';

      const slides = Array.from(rotator.querySelectorAll('[data-ann-slide]'));
      if (slides.length <= 1 || section.dataset.rotate !== 'true') return;

      rotator.dataset.transition = section.dataset.transition || 'flip';
      let activeIndex = slides.findIndex(slide => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;
      let intervalId = null;
      const speed = Math.max(1500, Number(section.dataset.rotateSpeed) || 4000);

      function showSlide(index) {
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        activeIndex = index;
      }

      function stop() {
        if (intervalId) window.clearInterval(intervalId);
        intervalId = null;
      }
      function start() {
        if (intervalId) return;
        intervalId = window.setInterval(() => showSlide((activeIndex + 1) % slides.length), speed);
      }

      start();
      if (section.dataset.pauseHover === 'true') {
        section.addEventListener('mouseenter', stop);
        section.addEventListener('mouseleave', start);
        section.addEventListener('focusin', stop);
        section.addEventListener('focusout', start);
      }
      document.addEventListener('shopify:section:unload', event => {
        if (event.target === section) stop();
      });
    }

    function initSection(section) {
      if (!section || section.dataset.annInitialized === 'true') return;
      section.dataset.annInitialized = 'true';
      initTimer(section);
      initRotator(section);
    }

    function initAll(scope) {
      if (scope && scope.matches && scope.matches(selector)) initSection(scope);
      if (scope && scope.querySelectorAll) scope.querySelectorAll(selector).forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    } else {
      initAll(document);
    }
    document.addEventListener('shopify:section:load', event => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-astro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__faqReady) return;
    window.__faqReady = true;

    function applyFilter(root) {
      var cat = root.getAttribute('data-cat') || 'all';
      var input = root.querySelector('.faq__search-input');
      var q = input ? input.value.trim().toLowerCase() : '';
      var visible = 0;
      root.querySelectorAll('.faq__item').forEach(function (item) {
        var okCat = cat === 'all' || item.getAttribute('data-cat') === cat;
        var okText = !q || (item.getAttribute('data-search') || '').indexOf(q) > -1;
        var show = okCat && okText;
        item.hidden = !show;
        if (show) visible++;
      });
      var none = root.querySelector('.faq__empty--none');
      if (none) none.hidden = visible > 0;
    }

    /* Only one answer open at a time (when enabled) */
    document.addEventListener('toggle', function (e) {
      var item = e.target;
      if (!item || !item.classList || !item.classList.contains('faq__item') || !item.open) return;
      var root = item.closest('.faq');
      if (!root || root.getAttribute('data-one') !== 'true') return;
      root.querySelectorAll('.faq__item[open]').forEach(function (other) {
        if (other !== item) other.removeAttribute('open');
      });
    }, true);

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.faq__tab');
      if (!tab) return;
      var root = tab.closest('.faq');
      if (!root) return;
      root.setAttribute('data-cat', tab.getAttribute('data-cat') || 'all');
      root.querySelectorAll('.faq__tab').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyFilter(root);
    });

    document.addEventListener('input', function (e) {
      var input = e.target.closest && e.target.closest('.faq__search-input');
      if (!input) return;
      var root = input.closest('.faq');
      if (root) applyFilter(root);
    });

    /* Theme editor: selecting a Question block opens it */
    document.addEventListener('shopify:block:select', function (e) {
      var item = e.target;
      if (!item || !item.classList || !item.classList.contains('faq__item')) return;
      var root = item.closest('.faq');
      if (root) {
        root.setAttribute('data-cat', 'all');
        var input = root.querySelector('.faq__search-input');
        if (input) input.value = '';
        root.querySelectorAll('.faq__tab').forEach(function (t) {
          var on = t.getAttribute('data-cat') === 'all';
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        applyFilter(root);
      }
      item.open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["festival"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var SELECTOR = '[data-nl-section]';
    var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function reduced() {
      return !!(reduceMq && reduceMq.matches);
    }

    function init(root) {
      if (!root || root.getAttribute('data-nl-ready') === 'true') return;
      var track = root.querySelector('[data-nl-track]');
      if (!track) return;
      root.setAttribute('data-nl-ready', 'true');

      var prevBtn = root.querySelector('[data-nl-prev]');
      var nextBtn = root.querySelector('[data-nl-next]');
      var thumb = root.querySelector('[data-nl-thumb]');
      var live = root.querySelector('[data-nl-live]');

      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var seconds = parseInt(root.getAttribute('data-interval'), 10) || 4;
      var pauseHover = root.getAttribute('data-pause-hover') === 'true';

      var state = { hover: false, touch: false, focus: false, visible: true, timer: null, resumeAt: 0, raf: 0 };
      var cleanups = [];

      function listen(target, type, fn, opts) {
        target.addEventListener(type, fn, opts);
        cleanups.push(function () { target.removeEventListener(type, fn, opts); });
      }

      function stepSize() {
        var card = track.querySelector('[data-nl-card]');
        if (!card) return track.clientWidth;
        var cs = window.getComputedStyle(track);
        var gap = parseFloat(cs.columnGap || cs.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function canScroll() {
        return track.scrollWidth - track.clientWidth > 4;
      }

      function atEnd() {
        return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }

      function go(dir) {
        var behavior = reduced() ? 'auto' : 'smooth';
        if (dir > 0) {
          if (atEnd()) {
            track.scrollTo({ left: 0, behavior: behavior });
          } else {
            track.scrollTo({ left: track.scrollLeft + stepSize(), behavior: behavior });
          }
        } else {
          if (track.scrollLeft <= 4) {
            track.scrollTo({ left: track.scrollWidth, behavior: behavior });
          } else {
            track.scrollTo({ left: track.scrollLeft - stepSize(), behavior: behavior });
          }
        }
      }

      function update() {
        state.raf = 0;
        var scrollable = canScroll();
        if (prevBtn) prevBtn.disabled = !scrollable;
        if (nextBtn) nextBtn.disabled = !scrollable;
        if (!thumb) return;
        var total = track.scrollWidth || 1;
        var width = Math.min(100, (track.clientWidth / total) * 100);
        var max = track.scrollWidth - track.clientWidth;
        var pos = max > 0 ? (track.scrollLeft / max) * (100 - width) : 0;
        thumb.style.width = width + '%';
        thumb.style.left = pos + '%';
      }

      function requestUpdate() {
        if (state.raf) return;
        state.raf = window.requestAnimationFrame(update);
      }

      function holdAutoplay() {
        state.resumeAt = Date.now() + seconds * 1000;
      }

      function tick() {
        if (!root.isConnected) { destroy(); return; }
        if (state.hover || state.touch || state.focus || !state.visible || document.hidden) return;
        if (reduced() || !canScroll()) return;
        if (Date.now() < state.resumeAt) return;
        go(1);
      }

      function start() {
        stop();
        if (!autoplay || reduced()) return;
        state.timer = window.setInterval(tick, seconds * 1000);
      }

      function stop() {
        if (state.timer) {
          window.clearInterval(state.timer);
          state.timer = null;
        }
      }

      function destroy() {
        stop();
        if (state.raf) window.cancelAnimationFrame(state.raf);
        cleanups.forEach(function (fn) { fn(); });
        cleanups = [];
        root.removeAttribute('data-nl-ready');
        root._nlDestroy = null;
      }
      root._nlDestroy = destroy;

      /* Scroll + resize -> progress bar */
      listen(track, 'scroll', requestUpdate, { passive: true });
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(requestUpdate);
        ro.observe(track);
        cleanups.push(function () { ro.disconnect(); });
      } else {
        listen(window, 'resize', requestUpdate);
      }

      /* Arrows */
      if (prevBtn) {
        listen(prevBtn, 'click', function () { holdAutoplay(); go(-1); });
      }
      if (nextBtn) {
        listen(nextBtn, 'click', function () { holdAutoplay(); go(1); });
      }

      /* Pause: hover */
      if (pauseHover) {
        listen(root, 'mouseenter', function () { state.hover = true; });
        listen(root, 'mouseleave', function () { state.hover = false; holdAutoplay(); });
      }

      /* Pause: touch + mouse drag */
      listen(track, 'touchstart', function () { state.touch = true; }, { passive: true });
      listen(track, 'touchend', function () { state.touch = false; holdAutoplay(); }, { passive: true });
      listen(track, 'touchcancel', function () { state.touch = false; holdAutoplay(); }, { passive: true });
      listen(track, 'pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        state.touch = true;
        var release = function () {
          state.touch = false;
          holdAutoplay();
          document.removeEventListener('pointerup', release);
          document.removeEventListener('pointercancel', release);
        };
        document.addEventListener('pointerup', release);
        document.addEventListener('pointercancel', release);
      });

      /* Pause: keyboard focus inside the section */
      listen(root, 'focusin', function (e) {
        try {
          if (e.target.matches && e.target.matches(':focus-visible')) state.focus = true;
        } catch (err) { /* older browsers: ignore */ }
      });
      listen(root, 'focusout', function () { state.focus = false; holdAutoplay(); });

      /* Pause when off-screen */
      if (window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          state.visible = entries[0].isIntersecting;
        }, { threshold: 0.1 });
        io.observe(root);
        cleanups.push(function () { io.disconnect(); });
      }

      /* Reduced motion changes */
      if (reduceMq) {
        var onMq = function () { start(); };
        if (reduceMq.addEventListener) {
          reduceMq.addEventListener('change', onMq);
          cleanups.push(function () { reduceMq.removeEventListener('change', onMq); });
        }
      }

      /* AJAX add to cart */
      listen(root, 'click', function (e) {
        var btn = e.target.closest('[data-nl-add]');
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();
        addToCart(btn);
      });

      function setLabel(btn, text) {
        var label = btn.querySelector('[data-nl-label]') || btn;
        label.textContent = text;
      }

      function addToCart(btn) {
        if (btn.disabled || btn.getAttribute('data-busy') === 'true') return;
        var id = parseInt(btn.getAttribute('data-variant-id'), 10);
        if (!id) return;

        var label = btn.querySelector('[data-nl-label]') || btn;
        var original = label.getAttribute('data-original') || label.textContent;
        label.setAttribute('data-original', original);

        var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        btn.setAttribute('data-busy', 'true');
        btn.setAttribute('aria-busy', 'true');
        btn.disabled = true;
        setLabel(btn, root.getAttribute('data-text-adding') || 'Adding...');

        function reset(delay) {
          window.setTimeout(function () {
            btn.disabled = false;
            btn.removeAttribute('data-busy');
            btn.removeAttribute('aria-busy');
            setLabel(btn, original);
          }, delay);
        }

        fetch(root_url + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
          .then(function (res) {
            return res.json().then(function (data) { return { ok: res.ok, data: data }; });
          })
          .then(function (result) {
            if (!result.ok) {
              throw new Error((result.data && (result.data.description || result.data.message)) || 'error');
            }
            setLabel(btn, root.getAttribute('data-text-added') || 'Added \u2713');
            if (live) live.textContent = root.getAttribute('data-text-added') || 'Added';
            refreshCart(root_url, result.data);
            reset(2000);
          })
          .catch(function () {
            setLabel(btn, root.getAttribute('data-text-error') || 'Error - try again');
            if (live) live.textContent = root.getAttribute('data-text-error') || 'Error';
            reset(2500);
          });
      }

      function refreshCart(root_url, item) {
        fetch(root_url + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var nodes = document.querySelectorAll('[data-cart-count], .cart-count-bubble span[aria-hidden="true"]');
            for (var i = 0; i < nodes.length; i++) nodes[i].textContent = cart.item_count;
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, item: item } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          })
          .catch(function () { /* cart badge refresh is best-effort */ });
      }

      update();
      start();
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }

    function destroyAll(scope) {
      var nodes = (scope || document).querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) {
        if (typeof nodes[i]._nlDestroy === 'function') nodes[i]._nlDestroy();
      }
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { destroyAll(e.target); });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-diwali"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mftReady) return;
    window.__mftReady = true;

    var desktop = window.matchMedia('(min-width: 750px)');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function all(root, sel) {
      return Array.prototype.slice.call(root.querySelectorAll(sel));
    }

    function isAccordion(root) {
      return root.getAttribute('data-accordion') === 'true' && !desktop.matches;
    }

    function syncAccordions(scope) {
      all(scope || document, '.mft').forEach(function (root) {
        var acc = isAccordion(root);
        all(root, 'details.mft-acc').forEach(function (d) {
          if (!acc) { d.open = true; }
        });
      });
    }

    function initCollapsed(scope) {
      /* On phones with accordion on, start every column closed */
      all(scope || document, '.mft').forEach(function (root) {
        if (isAccordion(root)) {
          all(root, 'details.mft-acc').forEach(function (d) { d.open = false; });
        }
      });
    }

    document.addEventListener('click', function (e) {
      var sum = e.target.closest && e.target.closest('.mft__sum');
      if (sum) {
        var root = sum.closest('.mft');
        if (root && !isAccordion(root)) e.preventDefault();
        return;
      }
      var top = e.target.closest && e.target.closest('.mft-top');
      if (top) {
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      }
    });

    function onScroll() {
      var show = (window.pageYOffset || document.documentElement.scrollTop) > 400;
      all(document, '.mft-top').forEach(function (b) { b.classList.toggle('is-visible', show); });
    }

    if (desktop.addEventListener) {
      desktop.addEventListener('change', function () { syncAccordions(); initCollapsed(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });

    function init(scope) {
      initCollapsed(scope);
      syncAccordions(scope);
      onScroll();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-loved-festive-diwali"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mlfReady) return;
    window.__mlfReady = true;

    var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function centerTab(tab) {
      try {
        var box = tab.parentElement;
        if (!box || box.scrollWidth <= box.clientWidth) return;
        var delta = tab.getBoundingClientRect().left - box.getBoundingClientRect().left - (box.clientWidth - tab.offsetWidth) / 2;
        box.scrollBy({ left: delta, behavior: 'smooth' });
      } catch (e) {}
    }

    function activate(tab, focus) {
      var wrap = tab.closest('.mlf');
      if (!wrap) return;
      var targetId = tab.getAttribute('aria-controls');
      wrap.querySelectorAll('.mlf__tab').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      wrap.querySelectorAll('.mlf__panel').forEach(function (p) {
        var on = p.id === targetId;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      centerTab(tab);
      if (focus) tab.focus({ preventScroll: true });
    }

    function updateCartUI(data) {
      try {
        var html = data && data.sections && data.sections['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (html && target) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('.shopify-section');
          if (src) { target.innerHTML = src.innerHTML; return; }
        }
      } catch (e) {}
      fetch(routeRoot + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.mlf__tab');
      if (tab) { activate(tab, false); return; }

      var arrow = e.target.closest('.mlf__arrow');
      if (arrow) {
        var grid = arrow.parentElement.querySelector('.mlf__grid');
        if (grid) {
          grid.scrollBy({ left: Number(arrow.dataset.dir) * grid.clientWidth * 0.9, behavior: 'smooth' });
        }
        return;
      }

      var btn = e.target.closest('.mlf__btn[data-variant]');
      if (!btn || btn.disabled || btn.dataset.busy === '1') return;

      var wrap = btn.closest('.mlf');
      var label = btn.querySelector('.mlf__btn-text') || btn;
      var original = wrap.dataset.atc || label.textContent;

      btn.dataset.busy = '1';
      btn.classList.add('is-loading');
      label.textContent = wrap.dataset.adding || 'Adding...';

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: Number(btn.dataset.variant),
          quantity: 1,
          sections: 'cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) throw new Error(res.data.description || 'error');
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          label.textContent = wrap.dataset.added || 'Added';
          updateCartUI(res.data);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (wrap.dataset.after === 'cart') { window.location.href = routeRoot + 'cart'; }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          label.textContent = wrap.dataset.error || 'Try again';
        })
        .then(function () {
          setTimeout(function () {
            btn.classList.remove('is-done', 'is-loading');
            btn.dataset.busy = '0';
            label.textContent = original;
          }, 1800);
        });
    });

    document.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('.mlf__tab');
      if (!tab) return;
      var tabs = Array.prototype.slice.call(tab.closest('.mlf__tabs').querySelectorAll('.mlf__tab'));
      var i = tabs.indexOf(tab);
      var next = null;
      if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      if (e.key === 'Home') next = tabs[0];
      if (e.key === 'End') next = tabs[tabs.length - 1];
      if (next) { e.preventDefault(); activate(next, true); }
    });

    /* Theme editor: selecting a Tab block switches to it */
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target.classList && e.target.classList.contains('mlf__tab') ? e.target : null;
      if (tab) activate(tab, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["most-loved-festive-pro"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__mlfReady) return;
    window.__mlfReady = true;

    var routeRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function activate(tab, focus) {
      var wrap = tab.closest('.mlf');
      if (!wrap) return;
      var targetId = tab.getAttribute('aria-controls');
      wrap.querySelectorAll('.mlf__tab').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      wrap.querySelectorAll('.mlf__panel').forEach(function (p) {
        var on = p.id === targetId;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      try { tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); } catch (e) {}
      if (focus) tab.focus({ preventScroll: true });
    }

    function updateCartUI(data) {
      try {
        var html = data && data.sections && data.sections['cart-icon-bubble'];
        var target = document.getElementById('cart-icon-bubble');
        if (html && target) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('.shopify-section');
          if (src) { target.innerHTML = src.innerHTML; return; }
        }
      } catch (e) {}
      fetch(routeRoot + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    }

    document.addEventListener('click', function (e) {
      var tab = e.target.closest('.mlf__tab');
      if (tab) { activate(tab, false); return; }

      var arrow = e.target.closest('.mlf__arrow');
      if (arrow) {
        var grid = arrow.parentElement.querySelector('.mlf__grid');
        if (grid) {
          grid.scrollBy({ left: Number(arrow.dataset.dir) * grid.clientWidth * 0.9, behavior: 'smooth' });
        }
        return;
      }

      var btn = e.target.closest('.mlf__btn[data-variant]');
      if (!btn || btn.disabled || btn.dataset.busy === '1') return;

      var wrap = btn.closest('.mlf');
      var label = btn.querySelector('.mlf__btn-text') || btn;
      var original = wrap.dataset.atc || label.textContent;

      btn.dataset.busy = '1';
      btn.classList.add('is-loading');
      label.textContent = wrap.dataset.adding || 'Adding...';

      fetch(routeRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: Number(btn.dataset.variant),
          quantity: 1,
          sections: 'cart-icon-bubble',
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) throw new Error(res.data.description || 'error');
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          label.textContent = wrap.dataset.added || 'Added';
          updateCartUI(res.data);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (wrap.dataset.after === 'cart') { window.location.href = routeRoot + 'cart'; }
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          label.textContent = wrap.dataset.error || 'Try again';
        })
        .then(function () {
          setTimeout(function () {
            btn.classList.remove('is-done', 'is-loading');
            btn.dataset.busy = '0';
            label.textContent = original;
          }, 1800);
        });
    });

    document.addEventListener('keydown', function (e) {
      var tab = e.target.closest && e.target.closest('.mlf__tab');
      if (!tab) return;
      var tabs = Array.prototype.slice.call(tab.closest('.mlf__tabs').querySelectorAll('.mlf__tab'));
      var i = tabs.indexOf(tab);
      var next = null;
      if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
      if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
      if (e.key === 'Home') next = tabs[0];
      if (e.key === 'End') next = tabs[tabs.length - 1];
      if (next) { e.preventDefault(); activate(next, true); }
    });

    /* Theme editor: selecting a Tab block switches to it */
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target.classList && e.target.classList.contains('mlf__tab') ? e.target : null;
      if (tab) activate(tab, false);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
